import styled from "styled-components/native";
import { View } from "react-native";

export const StyledViewContainer = styled(View)`
  flex-direction: row;
  height: 48px;
  border: none;
`;
